module.exports = __webpack_public_path__ + "static/media/dsjyBackground.94cebb5d.png";